import { useCallback, useRef, useEffect } from 'react'

type AnyEvent = MouseEvent | TouchEvent

const useClickOutsideWithException = (
  close: () => void,
  exception: React.MutableRefObject<any> | null
) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const handleClick = useCallback(
    (event: AnyEvent) => {
      if (ref?.current?.contains(event.target as Node)) return
      if (exception?.current?.contains(event.target as Node)) return
      close()
    },
    [close]
  )
  useEffect(() => {
    if (typeof document === 'undefined') return
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [handleClick])
  return ref
}

export default useClickOutsideWithException
